import { render } from "./DiretorioSelecionarDialog.vue?vue&type=template&id=0581f70e"
import script from "./DiretorioSelecionarDialog.vue?vue&type=script&lang=js"
export * from "./DiretorioSelecionarDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__